const STORAGE_KEY = 'bioedgeCheckoutContact'

/**
 * Persisted checkout contact (browser localStorage) so returning customers
 * see their last name, email, phone, address, and delivery preference.
 */
export function loadCheckoutContact() {
  if (typeof window === 'undefined') return null
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (!data || typeof data !== 'object') return null
    return {
      firstName: String(data.firstName ?? ''),
      lastName: String(data.lastName ?? ''),
      email: String(data.email ?? ''),
      phone: String(data.phone ?? ''),
      address: String(data.address ?? ''),
      shippingOption: data.shippingOption === 'express' ? 'express' : 'standard'
    }
  } catch (e) {
    console.warn('Unable to load checkout contact:', e)
    return null
  }
}

export function saveCheckoutContact({
  firstName,
  lastName,
  email,
  phone,
  address,
  shippingOption
}) {
  if (typeof window === 'undefined') return
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        firstName: firstName ?? '',
        lastName: lastName ?? '',
        email: email ?? '',
        phone: phone ?? '',
        address: address ?? '',
        shippingOption: shippingOption === 'express' ? 'express' : 'standard'
      })
    )
  } catch (e) {
    console.warn('Unable to save checkout contact:', e)
  }
}

export function applyCheckoutContactToData(vm, contact) {
  if (!contact) return
  vm.orderFirstName = contact.firstName
  vm.orderLastName = contact.lastName
  vm.orderEmail = contact.email
  vm.orderCell = contact.phone
  vm.orderAddress = contact.address
  vm.shippingOption = contact.shippingOption
}
